// Yamaha YDS diagnostic reference data: D-code definitions (name/conversion/unit) and DTC catalog (Indonesian).
export const YAMAHA_DCODES = [
 {
  "code": "01",
  "name": "Throttle position sensor signal 1",
  "actuator": false,
  "type": "convert",
  "num": 125.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "02",
  "name": "Atmospheric pressure",
  "actuator": false,
  "type": "convert",
  "num": 127.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "kpa",
  "decimals": 0
 },
 {
  "code": "03",
  "name": "Intake air pressure 1",
  "actuator": false,
  "type": "convert",
  "num": 127.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "kpa",
  "decimals": 0
 },
 {
  "code": "04",
  "name": "Intake air pressure 2",
  "actuator": false,
  "type": "convert",
  "num": 127.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "kpa",
  "decimals": 0
 },
 {
  "code": "05",
  "name": "Intake air temperature",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": -30.0,
  "unit": "degc",
  "decimals": 0
 },
 {
  "code": "06",
  "name": "Coolant temperature",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": -30.0,
  "unit": "degc",
  "decimals": 0
 },
 {
  "code": "07",
  "name": "Front/Rear wheel speed pulse",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "pulses",
  "decimals": 0
 },
 {
  "code": "08",
  "name": "Lean angle sensor",
  "actuator": false,
  "type": "convert",
  "num": 5.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "volt",
  "decimals": 1
 },
 {
  "code": "09",
  "name": "Fuel system voltage (battery voltage)",
  "actuator": false,
  "type": "convert",
  "num": 1875.0,
  "denom": 25600.0,
  "offset": 0.0,
  "unit": "volt",
  "decimals": 1
 },
 {
  "code": "0A",
  "name": "Oil temperature",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": -30.0,
  "unit": "degc",
  "decimals": 0
 },
 {
  "code": "0B",
  "name": "Engine temperature",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": -30.0,
  "unit": "degc",
  "decimals": 0
 },
 {
  "code": "0C",
  "name": "Cooling fan temperature",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": -30.0,
  "unit": "degc",
  "decimals": 0
 },
 {
  "code": "0D",
  "name": "Throttle position sensor signal 2",
  "actuator": false,
  "type": "convert",
  "num": 125.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "0E",
  "name": "Accelerator position sensor signal 1",
  "actuator": false,
  "type": "convert",
  "num": 125.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "0F",
  "name": "Accelerator position sensor signal 2",
  "actuator": false,
  "type": "convert",
  "num": 125.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "10",
  "name": "Front wheel speed pulse",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "pulses",
  "decimals": 0
 },
 {
  "code": "11",
  "name": "Bank angle",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "deg",
  "decimals": 0
 },
 {
  "code": "12",
  "name": "Wheel speed sensor3 pulse　『 for SURE-PARK 』",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "pulses",
  "decimals": 0
 },
 {
  "code": "14",
  "name": "[Sidestand switch] [Blue/Yellow lead of the ECU]",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "102000",
   "F0": "1020F0"
  }
 },
 {
  "code": "15",
  "name": "Neutral switch and clutch switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "102100",
   "F0": "1021F0"
  }
 },
 {
  "code": "18",
  "name": "Throttle switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "102400",
   "F0": "1024F0"
  }
 },
 {
  "code": "19",
  "name": "Gear position switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "102500",
   "F0": "1025F0",
   "01": "102501",
   "02": "102502",
   "03": "102503",
   "04": "102504",
   "05": "102505",
   "06": "102506",
   "10": "102510"
  }
 },
 {
  "code": "1A",
  "name": "Grip warmer",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "1B",
  "name": "Thumb warmer operation",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "1D",
  "name": "Suspension solenoid",
  "actuator": true,
  "type": "const",
  "consts": {
   "00": "102900",
   "F0": "1029F0"
  }
 },
 {
  "code": "1E",
  "name": "Cylinder #1 or #1-1 ignition coil",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "1F",
  "name": "Cylinder #2 or #2-1 ignition coil",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "20",
  "name": "Cylinder #3 or #1-2 ignition coil",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "21",
  "name": "Cylinder #4 or #2-2 ignition coil",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "22",
  "name": "Intake funnel servo motor",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "23",
  "name": "Wiper motor",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "24",
  "name": "Injector #1",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "25",
  "name": "Injector #2",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "26",
  "name": "Injector #3",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "27",
  "name": "Injector #4",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "28",
  "name": "Secondary injector #1",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "29",
  "name": "Secondary injector #2",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "2A",
  "name": "Secondary injector #3",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "2B",
  "name": "Secondary injector #4",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "2C",
  "name": "Bypass air solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "2D",
  "name": "VVA solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "2E",
  "name": "Purge cut valve solenoid 1",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "2F",
  "name": "Steering damper solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "30",
  "name": "Air induction system solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "31",
  "name": "Intake solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "32",
  "name": "Main relay",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "33",
  "name": "Radiator fan motor relay",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "34",
  "name": "Headlight relay",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "35",
  "name": "EXUP servo motor",
  "actuator": true,
  "type": "convert",
  "num": 280.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "36",
  "name": "ISC (idle speed control) valve / FID (fast idle solenoid)",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "37",
  "name": "Decompression solenoid",
  "actuator": true,
  "type": "convert",
  "num": 5.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "volt",
  "decimals": 1
 },
 {
  "code": "38",
  "name": "Sub-throttle servo motor",
  "actuator": true,
  "type": "convert",
  "num": 125.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "39",
  "name": "Grip warmer",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "3A",
  "name": "(Ignore)",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "3B",
  "name": "Passenger grip warmer relay",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "3C",
  "name": "EEPROM fault code display",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "3D",
  "name": "Malfunction history code display",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "3E",
  "name": "Malfunction history code erasure",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "3F",
  "name": "Malfunction code reinstatement",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "40",
  "name": "Setting history display",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "41",
  "name": "Setting map erasure",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "43",
  "name": "ISC correction value erasure",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "44",
  "name": "Switching correction value for ethanol mixed fuel",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "45",
  "name": "(Ignore)",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "46",
  "name": "Program version number",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "47",
  "name": "Primary sheave position",
  "actuator": false,
  "type": "convert",
  "num": 5.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "volt",
  "decimals": 1
 },
 {
  "code": "48",
  "name": "Secondary sheave speed pulse",
  "actuator": false,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "pulses",
  "decimals": 0
 },
 {
  "code": "4A",
  "name": "Mode switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "107400",
   "F0": "1074F0"
  }
 },
 {
  "code": "4B",
  "name": "Shift switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "107500",
   "F0": "1075F0"
  }
 },
 {
  "code": "4D",
  "name": "YCC-AT motor relay",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "4E",
  "name": "Primary sheave position initialization",
  "actuator": true,
  "type": "convert",
  "num": 5.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "volt",
  "decimals": 1
 },
 {
  "code": "4F",
  "name": "Gear position switch 2",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "107900",
   "F0": "1079F0"
  }
 },
 {
  "code": "50",
  "name": "Cruise control resume switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "108000",
   "F0": "1080F0"
  }
 },
 {
  "code": "51",
  "name": "Cruise control set switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "108100",
   "F0": "1081F0"
  }
 },
 {
  "code": "52",
  "name": "Cruise control cancel switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "108200",
   "F0": "1082F0"
  }
 },
 {
  "code": "53",
  "name": "Brake switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "108300",
   "F0": "1083F0"
  }
 },
 {
  "code": "56",
  "name": "Quick shift switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "108600",
   "F0": "1086F0"
  }
 },
 {
  "code": "57",
  "name": "Air-fuel control learning data erasure",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "58",
  "name": "High altitude setting",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "59",
  "name": "Wastegate valve solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "5A",
  "name": "Engine idling stop selection switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "109000",
   "F0": "1090F0"
  }
 },
 {
  "code": "5B",
  "name": "Air bypass valve solenoid",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "5C",
  "name": "SURE-PARK change lever  position",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "109200",
   "01": "109201",
   "58": "109258",
   "FE": "1092FE"
  }
 },
 {
  "code": "5D",
  "name": "FWD/RVS switch 『 for SURE-PARK 』",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "109300",
   "01": "109301",
   "02": "109302",
   "FE": "1093FE"
  }
 },
 {
  "code": "5E",
  "name": "Purge cut valve solenoid 2",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 },
 {
  "code": "5F",
  "name": "Shift sensor",
  "actuator": false,
  "type": "convert",
  "num": 5.0,
  "denom": 256.0,
  "offset": 0.0,
  "unit": "volt",
  "decimals": 1
 },
 {
  "code": "62",
  "name": "Clutch switch",
  "actuator": false,
  "type": "const",
  "consts": {
   "00": "109800",
   "F0": "1098F0"
  }
 },
 {
  "code": "64",
  "name": "Rich to lean sensor switch time (Bank1)",
  "actuator": false,
  "type": "convert",
  "num": 8.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "msec",
  "decimals": 0
 },
 {
  "code": "65",
  "name": "Lean to rich sensor switch time (Bank1)",
  "actuator": false,
  "type": "convert",
  "num": 8.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "msec",
  "decimals": 0
 },
 {
  "code": "66",
  "name": "Rich to lean sensor switch time (Bank2)",
  "actuator": false,
  "type": "convert",
  "num": 8.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "msec",
  "decimals": 0
 },
 {
  "code": "67",
  "name": "Lean to rich sensor switch time (Bank2)",
  "actuator": false,
  "type": "convert",
  "num": 8.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "msec",
  "decimals": 0
 },
 {
  "code": "68",
  "name": "Air-fuel control cycle data erasure(Beta)",
  "actuator": true,
  "type": "convert",
  "num": 1.0,
  "denom": 1.0,
  "offset": 0.0,
  "unit": "",
  "decimals": 0
 }
];

export const YAMAHA_DTC = [
 {
  "dtc": "1EC2",
  "code": "194",
  "name": "Rangkaian motor servo EXUP",
  "desc": "Kelainan sesaat terdeteksi pada rangkaian motor servo exup."
 },
 {
  "dtc": "1EC3",
  "code": "195",
  "name": "Sakelar standar samping atau kabel biru/kuning ECU",
  "desc": "Kelainan sesaat terdeteksi pada sakelar standar samping atau kabel biru/kuning ecu."
 },
 {
  "dtc": "1EC6",
  "code": "198",
  "name": "Sensor tekanan atmosfer",
  "desc": "Kelainan sesaat terdeteksi pada sensor tekanan atmosfer."
 },
 {
  "dtc": "1EC7",
  "code": "199",
  "name": "Sensor tekanan udara masuk 2",
  "desc": "Kelainan sesaat terdeteksi pada sensor tekanan udara masuk 2."
 },
 {
  "dtc": "1EC8",
  "code": "200",
  "name": "Sensor temperatur oli",
  "desc": "Kelainan sesaat terdeteksi pada sensor temperatur oli."
 },
 {
  "dtc": "1EC9",
  "code": "201",
  "name": "Sensor temperatur mesin",
  "desc": "Kelainan sesaat terdeteksi pada sensor temperatur mesin."
 },
 {
  "dtc": "1ECA",
  "code": "202",
  "name": "Solenoid dekompresi",
  "desc": "Kelainan sesaat terdeteksi pada solenoid dekompresi."
 },
 {
  "dtc": "1ECB",
  "code": "203",
  "name": "Sensor kemiringan kendaraan",
  "desc": "Kelainan sesaat terdeteksi pada sensor kemiringan kendaraan."
 },
 {
  "dtc": "1ECC",
  "code": "204",
  "name": "Tegangan sistem bahan bakar",
  "desc": "Kelainan sesaat pada tegangan pasokan injektor atau pompa bahan bakar."
 },
 {
  "dtc": "1ECD",
  "code": "205",
  "name": "Catu daya sistem kendaraan",
  "desc": "Kelainan sesaat pada tegangan pengisian kendaraan."
 },
 {
  "dtc": "1ECE",
  "code": "206",
  "name": "Sensor posisi throttle sekunder",
  "desc": "Kelainan sesaat terdeteksi pada sensor posisi throttle sekunder."
 },
 {
  "dtc": "1ECF",
  "code": "207",
  "name": "Sensor posisi akselerator",
  "desc": "Kelainan sesaat terdeteksi pada sensor posisi akselerator."
 },
 {
  "dtc": "1ED0",
  "code": "208",
  "name": "Sensor temperatur kipas pendingin",
  "desc": "Kelainan sesaat terdeteksi pada sensor temperatur kipas pendingin."
 },
 {
  "dtc": "1ED1",
  "code": "209",
  "name": "Sensor ketukan mesin",
  "desc": "Kelainan sesaat terdeteksi pada sensor ketukan mesin."
 },
 {
  "dtc": "1ED2",
  "code": "210",
  "name": "Sensor tekanan oli",
  "desc": "Kelainan sesaat terdeteksi pada sensor tekanan oli."
 },
 {
  "dtc": "1ED3",
  "code": "211",
  "name": "Sensor posisi puli primer",
  "desc": "Kelainan sesaat terdeteksi pada sensor posisi puli primer."
 },
 {
  "dtc": "1ED4",
  "code": "212",
  "name": "Sensor kecepatan puli sekunder",
  "desc": "Kelainan sesaat terdeteksi pada sensor kecepatan puli sekunder."
 },
 {
  "dtc": "1ED5",
  "code": "213",
  "name": "Sakelar pemanas genggaman",
  "desc": "Kelainan sesaat terdeteksi pada sakelar pemanas genggaman."
 },
 {
  "dtc": "1ED6",
  "code": "214",
  "name": "Sakelar pemanas ibu jari",
  "desc": "Kelainan sesaat terdeteksi pada sakelar pemanas ibu jari."
 },
 {
  "dtc": "1ED7",
  "code": "215",
  "name": "Sakelar tekanan oli",
  "desc": "Kelainan sesaat terdeteksi pada sakelar tekanan oli."
 },
 {
  "dtc": "1ED8",
  "code": "216",
  "name": "Sakelar pembatal kontrol jelajah",
  "desc": "Kelainan sesaat terdeteksi pada sakelar pembatal kontrol jelajah."
 },
 {
  "dtc": "1ED9",
  "code": "217",
  "name": "Sakelar RES/SET kontrol jelajah",
  "desc": "Kelainan sesaat terdeteksi pada sakelar res/set kontrol jelajah."
 },
 {
  "dtc": "1EDA",
  "code": "218",
  "name": "Sensor posisi poros engkol",
  "desc": "Kelainan sesaat terdeteksi pada sensor posisi poros engkol."
 },
 {
  "dtc": "1EDC",
  "code": "220",
  "name": "Sensor posisi gigi",
  "desc": "Kelainan sesaat terdeteksi pada sensor posisi gigi."
 },
 {
  "dtc": "1EE0",
  "code": "224",
  "name": "Koil pengapian 1",
  "desc": "Kelainan sesaat terdeteksi pada koil pengapian 1."
 },
 {
  "dtc": "1EE1",
  "code": "225",
  "name": "Koil pengapian 2",
  "desc": "Kelainan sesaat terdeteksi pada koil pengapian 2."
 },
 {
  "dtc": "1EE2",
  "code": "226",
  "name": "Koil pengapian 3",
  "desc": "Kelainan sesaat terdeteksi pada koil pengapian 3."
 },
 {
  "dtc": "1EE3",
  "code": "227",
  "name": "Koil pengapian 4",
  "desc": "Kelainan sesaat terdeteksi pada koil pengapian 4."
 },
 {
  "dtc": "1EE4",
  "code": "228",
  "name": "Solenoid dekompresi",
  "desc": "Kelainan sesaat terdeteksi pada solenoid dekompresi."
 },
 {
  "dtc": "1EE5",
  "code": "229",
  "name": "Injektor bahan bakar",
  "desc": "Kelainan sesaat terdeteksi pada injektor bahan bakar."
 },
 {
  "dtc": "1EE6",
  "code": "230",
  "name": "Injektor sekunder",
  "desc": "Kelainan sesaat terdeteksi pada injektor sekunder."
 },
 {
  "dtc": "1EE7",
  "code": "231",
  "name": "Katup pengatur putaran langsam (ISC)",
  "desc": "Kelainan sesaat terdeteksi pada katup pengatur putaran langsam (isc)."
 },
 {
  "dtc": "1EE8",
  "code": "232",
  "name": "Solenoid peredam kemudi",
  "desc": "Kelainan sesaat terdeteksi pada solenoid peredam kemudi."
 },
 {
  "dtc": "1EE9",
  "code": "233",
  "name": "Pemanas ibu jari",
  "desc": "Kelainan sesaat terdeteksi pada pemanas ibu jari."
 },
 {
  "dtc": "1EEA",
  "code": "234",
  "name": "Solenoid katup pengendali uap bahan bakar",
  "desc": "Kelainan sesaat terdeteksi pada solenoid katup pengendali uap bahan bakar."
 },
 {
  "dtc": "1EEB",
  "code": "235",
  "name": "Sensor tegangan internal SGCU",
  "desc": "Kerusakan internal SGCU pada sensor tegangan internal sgcu."
 },
 {
  "dtc": "1EEC",
  "code": "236",
  "name": "Sensor arus internal SGCU",
  "desc": "Kerusakan internal SGCU pada sensor arus internal sgcu."
 },
 {
  "dtc": "1EED",
  "code": "237",
  "name": "Sensor temperatur internal SGCU",
  "desc": "Kerusakan internal SGCU pada sensor temperatur internal sgcu."
 },
 {
  "dtc": "1EEE",
  "code": "238",
  "name": "Relai utama",
  "desc": "Hubungan singkat pada relai utama."
 },
 {
  "dtc": "1EF0",
  "code": "240",
  "name": "Sensor oksigen 1 (batas kompensasi atas)",
  "desc": "Kompensasi sensor oksigen 1 tertahan pada batas atas."
 },
 {
  "dtc": "1EF1",
  "code": "241",
  "name": "Sensor oksigen 1 (batas kompensasi bawah)",
  "desc": "Kompensasi sensor oksigen 1 tertahan pada batas bawah."
 },
 {
  "dtc": "1EF2",
  "code": "242",
  "name": "Katup ISC (batas kompensasi atas)",
  "desc": "Kompensasi katup ISC tertahan pada batas atas."
 },
 {
  "dtc": "1EF3",
  "code": "243",
  "name": "Katup ISC (batas kompensasi bawah)",
  "desc": "Kompensasi katup ISC tertahan pada batas bawah."
 },
 {
  "dtc": "1EF4",
  "code": "244",
  "name": "Kesulitan menghidupkan mesin",
  "desc": "Terdeteksi kondisi mesin sulit atau tidak dapat dihidupkan."
 },
 {
  "dtc": "1EF5",
  "code": "245",
  "name": "Mesin mati mendadak",
  "desc": "Terdeteksi mesin mati mendadak."
 },
 {
  "dtc": "1EF6",
  "code": "246",
  "name": "Kontrol jelajah",
  "desc": "Terdeteksi sistem kontrol jelajah mati secara otomatis."
 },
 {
  "dtc": "1EF7",
  "code": "247",
  "name": "Kode pengembangan",
  "desc": "Kode peristiwa untuk pengembangan; bukan kerusakan sistem."
 },
 {
  "dtc": "1EF8",
  "code": "248",
  "name": "Kode pengembangan",
  "desc": "Kode peristiwa untuk pengembangan; bukan kerusakan sistem."
 },
 {
  "dtc": "1EF9",
  "code": "249",
  "name": "Kode pengembangan",
  "desc": "Kode peristiwa untuk pengembangan; bukan kerusakan sistem."
 },
 {
  "dtc": "1EFA",
  "code": "250",
  "name": "Kode pengembangan",
  "desc": "Kode peristiwa untuk pengembangan; bukan kerusakan sistem."
 },
 {
  "dtc": "1EFB",
  "code": "251",
  "name": "Sensor perpindahan gigi",
  "desc": "Kelainan sesaat terdeteksi pada sensor perpindahan gigi."
 },
 {
  "dtc": "1EFD",
  "code": "253",
  "name": "Temperatur internal ECU",
  "desc": "Temperatur internal ECU terlalu tinggi."
 },
 {
  "dtc": "1EFE",
  "code": "254",
  "name": "Tegangan berlebih SGCU",
  "desc": "Terdeteksi tegangan berlebih pada SGCU."
 },
 {
  "dtc": "1EFF",
  "code": "255",
  "name": "Arus berlebih SGCU",
  "desc": "Terdeteksi arus berlebih pada SGCU."
 },
 {
  "dtc": "056C",
  "code": "P056C",
  "name": "Sakelar pembatal kontrol jelajah",
  "desc": "Sinyal sakelar pembatal kontrol jelajah tidak diterima dengan benar (kopling, rem depan, rem belakang atau pembatal pada genggaman)."
 },
 {
  "dtc": "0564",
  "code": "P0564",
  "name": "Sakelar pengaturan kontrol jelajah",
  "desc": "Sinyal sakelar pengaturan kontrol jelajah tidak diterima dengan benar."
 },
 {
  "dtc": "1EC0",
  "code": "192",
  "name": "Sensor tekanan udara masuk 1 (MAP)",
  "desc": "Kelainan sesaat pada sensor tekanan udara masuk 1 (MAP). Acuan pemeriksaan: kode 13, P0107 atau P0108."
 },
 {
  "dtc": "1EC1",
  "code": "193",
  "name": "Sensor posisi throttle (TPS)",
  "desc": "Kelainan sesaat pada sensor posisi throttle (TPS). Acuan pemeriksaan: kode 15, P0122, P0123, P0222, P0223 atau P2135."
 },
 {
  "dtc": "1EC4",
  "code": "196",
  "name": "Sensor temperatur pendingin",
  "desc": "Kelainan sesaat pada sensor temperatur pendingin. Acuan pemeriksaan: kode 21, P0117 atau P0118."
 },
 {
  "dtc": "1EC5",
  "code": "197",
  "name": "Sensor temperatur udara masuk",
  "desc": "Kelainan sesaat pada sensor temperatur udara masuk. Acuan pemeriksaan: kode 22, P0112 atau P0113."
 },
 {
  "dtc": "0030",
  "code": "P0030",
  "name": "O2 sensor heater",
  "desc": "Rangkaian pemanas sensor oksigen terbuka atau mengalami hubungan pendek; penggerak pemanas sensor tidak berfungsi dengan baik."
 },
 {
  "dtc": "0036",
  "code": "P0036",
  "name": "Rear O2 sensor heater",
  "desc": "Sirkuit terbuka pada pemanas sensor O2 belakang atau penggerak pemanas rusak."
 },
 {
  "dtc": "0050",
  "code": "P0050",
  "name": "O2 sensor 2 heater",
  "desc": "Sirkuit terbuka pada pemanas sensor O2 2 atau penggerak cacat."
 },
 {
  "dtc": "0056",
  "code": "P0056",
  "name": "Rear O2 sensor heater 2",
  "desc": "Sirkuit terbuka atau penggerak pemanas rusak pada pemanas sensor O2 belakang No. 2."
 },
 {
  "dtc": "0069",
  "code": "P0069",
  "name": "Intake air pressure sensor or atmospheric pressure sens",
  "desc": "Saat sakelar utama menyala atau pada posisi ON, ada perbedaan besar dalam nilai tegangan di antara sensor tekanan udara masuk (I"
 },
 {
  "dtc": "00D1",
  "code": "P00D1",
  "name": "O2 sensor heater 1 (Performance degradation)",
  "desc": "Sensor O2 1 tidak beroperasi meskipun pemanas sudah ON dengan cukup"
 },
 {
  "dtc": "00D2",
  "code": "P00D2",
  "name": "Rear O2 sensor heater 1 (Performance degradation)",
  "desc": "Sensor O2 belakang No. 1 tidak berfungsi meskipun pemanas dalam kondisi MENYALA secara mencukupi."
 },
 {
  "dtc": "00D3",
  "code": "P00D3",
  "name": "O2 sensor heater 2 (Performance degradation)",
  "desc": "Sensor O2 2 tidak beroperasi meskipun pemanas sudah ON dengan cukup"
 },
 {
  "dtc": "00D4",
  "code": "P00D4",
  "name": "Rear O2 sensor heater 2 (Performance degradation)",
  "desc": "Sensor O2 belakang No. 1 tidak berfungsi meskipun pemanas dalam kondisi MENYALA secara mencukupi."
 },
 {
  "dtc": "0105",
  "code": "P0105",
  "name": "Intake air pressure sensor 1 (Out of signal range)",
  "desc": "Sinyal tekanan masuk terdeteksi di luar rentang penggunaan normal"
 },
 {
  "dtc": "0106",
  "code": "P0106",
  "name": "Intake air pressure sensor 1",
  "desc": "Sensor tekanan udara masuk rusak (diakibatkan selang sensor tersumbat atau terlepas)."
 },
 {
  "dtc": "0107",
  "code": "P0107",
  "name": "Intake air pressure sensor 1 (ground short circuit) * T",
  "desc": "Terlepas atau terjadi hubungan pendek pada kabel sensor tekanan udara masuk/intake air pressure sensor."
 },
 {
  "dtc": "0108",
  "code": "P0108",
  "name": "Intake air pressure sensor 1 (power short circuit) * Th",
  "desc": "Terlepas atau terjadi hubungan pendek pada kabel sensor tekanan udara masuk/intake air pressure sensor."
 },
 {
  "dtc": "0110",
  "code": "P0110",
  "name": "Intake air temperature sensor (Signal stack)",
  "desc": "Sinyal dari sensor temperatur masuk tidak berubah"
 },
 {
  "dtc": "0111",
  "code": "P0111",
  "name": "Intake air temperature sensor (Out of signal range)",
  "desc": "Sinyal temperatur masuk terdeteksi di luar rentang penggunaan normal"
 },
 {
  "dtc": "0112",
  "code": "P0112",
  "name": "Intake air temperature sensor (ground short circuit)",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada Sensor temperatur udara masuk."
 },
 {
  "dtc": "0113",
  "code": "P0113",
  "name": "Intake air temperature sensor (open or power short circ",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada Sensor temperatur udara masuk."
 },
 {
  "dtc": "0115",
  "code": "P0115",
  "name": "Water temperature sensor (Signal stack)",
  "desc": "Sinyal sensor temperatur air tidak berubah"
 },
 {
  "dtc": "0116",
  "code": "P0116",
  "name": "Water temperature sensor (Out of signal range)",
  "desc": "Sinyal sensor temperatur air terdeteksi di luar rentang penggunaan normal"
 },
 {
  "dtc": "0117",
  "code": "P0117",
  "name": "Coolant temperature sensor (ground short circuit)",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur coolant"
 },
 {
  "dtc": "0118",
  "code": "P0118",
  "name": "Coolant temperature sensor (open or power short circuit",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur coolant"
 },
 {
  "dtc": "0122",
  "code": "P0122",
  "name": "[Models equipped with YCC-T] Throttle position sensor (",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor throttle position sensor."
 },
 {
  "dtc": "0123",
  "code": "P0123",
  "name": "[Models equipped with YCC-T] Throttle position sensor (",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor throttle position sensor."
 },
 {
  "dtc": "0132",
  "code": "P0132",
  "name": "O2 sensor (power short circuit)",
  "desc": "Sirkuit terbuka atau hubungan pendek pada kabel sensor O2."
 },
 {
  "dtc": "0133",
  "code": "P0133",
  "name": "O2 sensor 1 (Response delay)",
  "desc": "Perubahan sinyal keluaran sensor O2 1 lambat"
 },
 {
  "dtc": "0134",
  "code": "P0134",
  "name": "O2 sensor 1 (Signal stack)",
  "desc": "Sinyal dari sensor O2 1 tidak berubah"
 },
 {
  "dtc": "0138",
  "code": "P0138",
  "name": "Rear O2 sensor (power short circuit)",
  "desc": "Sirkuit terbuka atau korsleting pada penghubung sensor O2 belakang No. 1."
 },
 {
  "dtc": "0139",
  "code": "P0139",
  "name": "Rear O2 sensor 1 (Response delay)",
  "desc": "Perubahan sinyal output pada sensor O2 belakang No. 1 lambat."
 },
 {
  "dtc": "0140",
  "code": "P0140",
  "name": "Rear O2 sensor 1 (Signal stack)",
  "desc": "Nilai sinyal pada sensor O2 belakang No. 1 tidak berubah."
 },
 {
  "dtc": "0152",
  "code": "P0152",
  "name": "O2 sensor 2 (power short circuit)",
  "desc": "Sirkuit terbuka atau hubungan pendek pada kabel sensor O2 2."
 },
 {
  "dtc": "0153",
  "code": "P0153",
  "name": "O2 sensor 2 (Response delay)",
  "desc": "Perubahan sinyal keluaran sensor O2 2 lambat"
 },
 {
  "dtc": "0154",
  "code": "P0154",
  "name": "O2 sensor 2 (Signal stack)",
  "desc": "Nilai sinyal sensor O2 2 tidak berubah"
 },
 {
  "dtc": "0158",
  "code": "P0158",
  "name": "Rear O2 sensor 2 (power short circuit)",
  "desc": "Sirkuit terbuka atau korsleting pada penghubung sensor O2 belakang No. 2."
 },
 {
  "dtc": "0159",
  "code": "P0159",
  "name": "Rear O2 sensor 2 (Response delay)",
  "desc": "Perubahan sinyal output pada sensor O2 belakang No. 2 lambat."
 },
 {
  "dtc": "0160",
  "code": "P0160",
  "name": "Rear O2 sensor 2 (Signal stack)",
  "desc": "Nilai sinyal pada sensor O2 belakang No. 2 tidak berubah."
 },
 {
  "dtc": "0170",
  "code": "P0170",
  "name": "Fuel system",
  "desc": "Volume injeksi bahan bakar salah."
 },
 {
  "dtc": "0173",
  "code": "P0173",
  "name": "Fuel system 2",
  "desc": "Volume injeksi bahan bakar salah."
 },
 {
  "dtc": "0195",
  "code": "P0195",
  "name": "Engine temperature sensor (Signal stack)",
  "desc": "Sinyal dari sensor temperatur mesin tidak berubah"
 },
 {
  "dtc": "0196",
  "code": "P0196",
  "name": "Engine temperature sensor (Out of signal range)",
  "desc": "Sinyal temperatur mesin terdeteksi di luar rentang penggunaan normal"
 },
 {
  "dtc": "0197",
  "code": "P0197",
  "name": "Engine temperature sensor (open circuit / short to grou",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur mesin."
 },
 {
  "dtc": "0198",
  "code": "P0198",
  "name": "Engine temperature sensor (open circuit / short to batt",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur mesin."
 },
 {
  "dtc": "0201",
  "code": "P0201",
  "name": "Primary injector #1 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector primary"
 },
 {
  "dtc": "0202",
  "code": "P0202",
  "name": "Primary injector #2 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector primary"
 },
 {
  "dtc": "0203",
  "code": "P0203",
  "name": "Primary injector #3 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector primary"
 },
 {
  "dtc": "0204",
  "code": "P0204",
  "name": "Primary injector #4 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector primary"
 },
 {
  "dtc": "0222",
  "code": "P0222",
  "name": "Throttle position sensor (ground short circuit for sign",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor throttle position sensor."
 },
 {
  "dtc": "0223",
  "code": "P0223",
  "name": "Throttle position sensor (open or power short circuit f",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor throttle position sensor."
 },
 {
  "dtc": "0300",
  "code": "P0300",
  "name": "Multiple cylinder misfire detected",
  "desc": "Loncatan bunga api terdeteksi di beberapa silinder"
 },
 {
  "dtc": "0301",
  "code": "P0301",
  "name": "Cylinder 1 misfire detected",
  "desc": "Loncatan bunga api terdeteksi di silinder pertama"
 },
 {
  "dtc": "0302",
  "code": "P0302",
  "name": "Cylinder 2 misfire detected",
  "desc": "Loncatan bunga api terdeteksi di silinder kedua"
 },
 {
  "dtc": "0303",
  "code": "P0303",
  "name": "Cylinder 3 misfire detected",
  "desc": "Loncatan bunga api terdeteksi di silinder ketiga"
 },
 {
  "dtc": "0304",
  "code": "P0304",
  "name": "Cylinder 4 misfire detected",
  "desc": "Loncatan bunga api terdeteksi di slilinder keempat"
 },
 {
  "dtc": "0335",
  "code": "P0335",
  "name": "Crankshaft position sensor",
  "desc": "Sinyal normal tidak diterima dari sensor posisi poros engkol."
 },
 {
  "dtc": "0340",
  "code": "P0340",
  "name": "Cylinder identification sensor",
  "desc": "Sinyal normal tidak diterima dari sensor identifikasi silinder."
 },
 {
  "dtc": "0342",
  "code": "P0342",
  "name": "Cam sensor (short to ground)",
  "desc": "Terdeteksi adanya hubungan pendek atau sambungan putus di sensor posisi cam"
 },
 {
  "dtc": "0343",
  "code": "P0343",
  "name": "Cam sensor (open circuit / short to battery)",
  "desc": "Terdeteksi adanya hubungan pendek atau sambungan putus di sensor posisi cam"
 },
 {
  "dtc": "0351",
  "code": "P0351",
  "name": "Ignition coil (#1)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #1 ignition coil."
 },
 {
  "dtc": "0352",
  "code": "P0352",
  "name": "Ignition coil (#2)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #2 ignition coil."
 },
 {
  "dtc": "0353",
  "code": "P0353",
  "name": "Ignition coil (#3)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #3 ignition coil."
 },
 {
  "dtc": "0354",
  "code": "P0354",
  "name": "Ignition coil (#4)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #4 ignition coil."
 },
 {
  "dtc": "0357",
  "code": "P0357",
  "name": "Ignition system (#12)",
  "desc": "Kabel utama koil pengapian cacat"
 },
 {
  "dtc": "0358",
  "code": "P0358",
  "name": "Ignition system (#22)",
  "desc": "Kabel utama koil pengapian cacat"
 },
 {
  "dtc": "0420",
  "code": "P0420",
  "name": "Catalyst System Efficiency Below Threshold Bank 1",
  "desc": "Penurunan kemampuan pemurnian gas buang katalis terdeteksi."
 },
 {
  "dtc": "0430",
  "code": "P0430",
  "name": "Catalyst System Efficiency Below Threshold Bank 2",
  "desc": "Penurunan kemampuan pemurnian gas buang katalis terdeteksi."
 },
 {
  "dtc": "0458",
  "code": "P0458",
  "name": "Purge cut valve solenoid",
  "desc": "Rangkaian terbuka purge cut valve solenoid"
 },
 {
  "dtc": "0475",
  "code": "P0475",
  "name": "EXUP servo motor circuit (Performance degradation)",
  "desc": "Perubahan sinyal posisi motor servo EXUP lambat saat penggerak dikendalikan"
 },
 {
  "dtc": "0476",
  "code": "P0476",
  "name": "EXUP servo motor",
  "desc": "Terdeteksi servo motor EXUP macet."
 },
 {
  "dtc": "0480",
  "code": "P0480",
  "name": "Radiator fan relay",
  "desc": "Sirkuit terbuka atau pendek pada relai KIPAS radiator"
 },
 {
  "dtc": "048B",
  "code": "P048B",
  "name": "EXUP Opening sensor (Signal stack)",
  "desc": "Sinyal posisi motor servo EXUP tidak berubah saat penggerak dikendalikan"
 },
 {
  "dtc": "048C",
  "code": "P048C",
  "name": "EXUP Opening sensor (Out of signal range)",
  "desc": "Sinyal posisi motor servo EXUP berada di luar jangkauan kendali"
 },
 {
  "dtc": "048D",
  "code": "P048D",
  "name": "EXUP servo motor circuit (open or ground short circuit)",
  "desc": "Terjadi hubungan terbuka atau singkat pada sirkuit EXUP servo motor."
 },
 {
  "dtc": "048E",
  "code": "P048E",
  "name": "EXUP servo motor circuit (power short circuit)",
  "desc": "Terjadi hubungan terbuka atau singkat pada sirkuit EXUP servo motor."
 },
 {
  "dtc": "0500",
  "code": "P0500",
  "name": "Speed sensor or Front/rear speed sensor",
  "desc": "Tidak diterima sinyal yang normal dari sensor kecepatan kendaraan."
 },
 {
  "dtc": "0507",
  "code": "P0507",
  "name": "[For FID/ISC valve] FID/ISC valve (stuck fully open) [F",
  "desc": "Kecepatan tinggi saat menganggur."
 },
 {
  "dtc": "0511",
  "code": "P0511",
  "name": "ISC valve / FID (open or short circuit)",
  "desc": "[ISC] Sirkuit terbuka atau pendek pada kabel katup ISC (kontrol kecepatan tak aktif). [FID] Sirkuit terbuka atau pendek pada sol"
 },
 {
  "dtc": "0560",
  "code": "P0560",
  "name": "Vehicle system power supply",
  "desc": "tegangan berlebih ke ECU."
 },
 {
  "dtc": "0563",
  "code": "P0563",
  "name": "Vehicle system power supply (Out of voltage range)",
  "desc": "Regulator tidak berfungsi normal<br/> Baterai tidak terisi dengan normal"
 },
 {
  "dtc": "0600",
  "code": "P0600",
  "name": "ECU internal malfunction (communication)",
  "desc": "Malafungsi internal ECU"
 },
 {
  "dtc": "0601",
  "code": "P0601",
  "name": "ECU internal malfunction",
  "desc": "Kerusakan pada memory ECU."
 },
 {
  "dtc": "0606",
  "code": "P0606",
  "name": "ECU internal malfunction (malfunction in YCC-T input or",
  "desc": "Kerusakan pada memory ECU."
 },
 {
  "dtc": "0620",
  "code": "P0620",
  "name": "SGCU",
  "desc": "Kontrol SGCU tidak berfungsi dengan baik."
 },
 {
  "dtc": "062F",
  "code": "P062F",
  "name": "Error in writing on EEPROM",
  "desc": "Error terdeteksi ketika membaca atau menulis pada EEPROM."
 },
 {
  "dtc": "0638",
  "code": "P0638",
  "name": "Throttle servo motor",
  "desc": "Kerusakan terjadi pada penggerak YCC-T."
 },
 {
  "dtc": "0657",
  "code": "P0657",
  "name": "Fuel system voltage",
  "desc": "tegangan berlebih ke Fuel Pump dan Injector."
 },
 {
  "dtc": "0700",
  "code": "P0700",
  "name": "Transmission Control System",
  "desc": "Operasi sistem kontrol transmisi tidak normal terdeteksi."
 },
 {
  "dtc": "0730",
  "code": "P0730",
  "name": "Abnormal gear position while vehicle is driven",
  "desc": "Kecepatan mesin dan sinyal sensor posisi gigi tidak sesuai saat kendaraan dikendarai."
 },
 {
  "dtc": "0914",
  "code": "P0914",
  "name": "Gear position sensor (Signal stack)",
  "desc": "Sinyal dari sensor posisi gear tidak berubah"
 },
 {
  "dtc": "0915",
  "code": "P0915",
  "name": "Gear position sensor (Out of signal range)",
  "desc": "Sinyal posisi gear terdeteksi di luar rentang penggunaan normal"
 },
 {
  "dtc": "0916",
  "code": "P0916",
  "name": "[Models equipped with YCC-S] Shift cam sensor (open or ",
  "desc": "[Model yang dilengkapi YCC-S]<br/> Sinyal normal tidak diterima dari MCU.<br/> [Model lain]<br/> Sinyal normal tidak diterima da"
 },
 {
  "dtc": "0917",
  "code": "P0917",
  "name": "[Models equipped with YCC-S] Shift cam sensor (power sh",
  "desc": "[Model yang dilengkapi YCC-S]<br/> Sinyal normal tidak diterima dari MCU.<br/> [Model lain]<br/> Sinyal normal tidak diterima da"
 },
 {
  "dtc": "1004",
  "code": "P1004",
  "name": "Intake air pressure sensor 1 or 2",
  "desc": "Perbedaan tegangan antara sensor tekanan udara masuk (IAPS) 1 atau 2 lebih besar daripada saat sakelar utama menyala atau pada p"
 },
 {
  "dtc": "1005",
  "code": "P1005",
  "name": "Abnormal engine intake air volume (too high)",
  "desc": "Kecepatan mesin menganggur tinggi. Deselerasi atau perlambatan buruk saat sedang melaju."
 },
 {
  "dtc": "1300",
  "code": "P1300",
  "name": "Crankshaft position sensor 2",
  "desc": "Tidak diterima sinyal yang benar dari sensor posisi crankshaft 2."
 },
 {
  "dtc": "1400",
  "code": "P1400",
  "name": "AI solenoid (open or ground short circuit)",
  "desc": "Sirkuit terbuka atau hubungan pendek pada kabel solenoid AI."
 },
 {
  "dtc": "1500",
  "code": "P1500",
  "name": "Speed sensor, neutral SW, or clutch SW",
  "desc": "Tidak diterima sinyal yang benar dari sensor kecepatan kendaraan.<br/> Sirkuit terbuka atau pendek pada SW netral.<br/> Sirkuit "
 },
 {
  "dtc": "1600",
  "code": "P1600",
  "name": "Lean angle sensor (defective lean angle sensor in IMU)",
  "desc": "Sensor sudut miring rusak di IMU."
 },
 {
  "dtc": "1601",
  "code": "P1601",
  "name": "Sidestand switch or Blue/Yellow lead of the ECU",
  "desc": "Terjadi hubungan terbuka atau singkat pada rangkaian ECU input line (blue/yellow lead)"
 },
 {
  "dtc": "1602",
  "code": "P1602",
  "name": "Faulty ECU",
  "desc": "Kerusakan internal pada sirkuit ECU."
 },
 {
  "dtc": "1604",
  "code": "P1604",
  "name": "Lean angle sensor (ground short circuit)",
  "desc": "Sirkuit terbuka atau hubungan pendek pada kabel sensor sudut miring."
 },
 {
  "dtc": "1605",
  "code": "P1605",
  "name": "Lean angle sensor (open or power short circuit)",
  "desc": "Sirkuit terbuka atau hubungan pendek pada kabel sensor sudut miring."
 },
 {
  "dtc": "1606",
  "code": "P1606",
  "name": "Intake air pressure sensor 2 (ground short circuit)",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada Sensor tekanan udara masuk 2"
 },
 {
  "dtc": "1607",
  "code": "P1607",
  "name": "Intake air pressure sensor 2 (open or power short circu",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada Sensor tekanan udara masuk 2"
 },
 {
  "dtc": "1608",
  "code": "P1608",
  "name": "Intake air temperature sensor 2 (Out of signal range)",
  "desc": "Sinyal tekanan masuk terdeteksi di luar rentang penggunaan normal"
 },
 {
  "dtc": "1609",
  "code": "P1609",
  "name": "Intake air temperature sensor 2 (Piping system abnormal",
  "desc": "Rusaknya sistem sensor tekanan tinggi terdeteksi (lubang tersumbat atau terputusnya sambungan sensor)"
 },
 {
  "dtc": "1806",
  "code": "P1806",
  "name": "Shift sensor (open or short circuit)",
  "desc": "Sirkuit terbuka atau pendek dari sensor shift."
 },
 {
  "dtc": "1807",
  "code": "P1807",
  "name": "Shift sensor (ground short circuit)",
  "desc": "Sirkuit pendek bumi dari sensor shift"
 },
 {
  "dtc": "1E01",
  "code": "01",
  "name": "Wheel speed sensor3 『for SURE-PARK』",
  "desc": "Sinyal normal tidak dikirimkan ke ECU."
 },
 {
  "dtc": "1E03",
  "code": "03",
  "name": "SURE-PARK relay",
  "desc": "Relai utama FWD/RVS tidak beroperasi."
 },
 {
  "dtc": "1E08",
  "code": "08",
  "name": "Gear position sensor",
  "desc": "Sinyal normal tidak diterima dari sensor posisi gigi."
 },
 {
  "dtc": "1E11",
  "code": "11",
  "name": "Cylinder identification sensor",
  "desc": "Sinyal normal tidak diterima dari sensor identifikasi silinder."
 },
 {
  "dtc": "1E12",
  "code": "12",
  "name": "Crankshaft position sensor",
  "desc": "Sinyal normal tidak diterima dari sensor posisi poros engkol."
 },
 {
  "dtc": "1E13",
  "code": "13",
  "name": "Intake air pressure sensor 1",
  "desc": "Terlepas atau terjadi hubungan pendek pada kabel sensor tekanan udara masuk/intake air pressure sensor."
 },
 {
  "dtc": "1E14",
  "code": "14",
  "name": "Intake air pressure sensor 1",
  "desc": "Sensor tekanan udara masuk rusak (diakibatkan selang sensor tersumbat atau terlepas)."
 },
 {
  "dtc": "1E15",
  "code": "15",
  "name": "Throttle position sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor throttle position sensor."
 },
 {
  "dtc": "1E16",
  "code": "16",
  "name": "Throttle position sensor",
  "desc": "Terdeteksinya throttle position sensor macet."
 },
 {
  "dtc": "1E17",
  "code": "17",
  "name": "EXUP servo motor circuit",
  "desc": "Terjadi hubungan terbuka atau singkat pada sirkuit EXUP servo motor."
 },
 {
  "dtc": "1E18",
  "code": "18",
  "name": "EXUP servo motor",
  "desc": "Terdeteksi servo motor EXUP macet."
 },
 {
  "dtc": "1E19",
  "code": "19",
  "name": "Sidestand switch or Blue/Yellow lead of the ECU",
  "desc": "[Untuk MC]<br/> Sirkuit terbuka atau pendek pada jalur input ECU (kabel biru/kuning).<br/> [Untuk SMB]<br/> Solenoid katup waste"
 },
 {
  "dtc": "1E20",
  "code": "20",
  "name": "Intake air pressure sensor 1 or 2 or Atmospheric pressu",
  "desc": "Saat kontak ON, terdapat perbedaan tegangan yang besar antara sensor tekanan udara masuk 1 dan sensor tekanan udara masuk 2 atau sensor tekanan atmosfer."
 },
 {
  "dtc": "1E21",
  "code": "21",
  "name": "Coolant temperature sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur coolant"
 },
 {
  "dtc": "1E22",
  "code": "22",
  "name": "Intake air temperature sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada Sensor temperatur udara masuk."
 },
 {
  "dtc": "1E23",
  "code": "23",
  "name": "Atmospheric pressure sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor tekanan atmosfir"
 },
 {
  "dtc": "1E24",
  "code": "24",
  "name": "O2 sensor 1",
  "desc": "Sensor O2 Tidak beroperasi."
 },
 {
  "dtc": "1E25",
  "code": "25",
  "name": "Intake air pressure sensor 2",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada Sensor tekanan udara masuk 2"
 },
 {
  "dtc": "1E26",
  "code": "26",
  "name": "Intake air pressure sensor 2",
  "desc": "Sensor tekanan udara masuk gagal. (Karena tersumbatnya selang atau sensor yang terputus)"
 },
 {
  "dtc": "1E27",
  "code": "27",
  "name": "Oil temperature sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur oli."
 },
 {
  "dtc": "1E28",
  "code": "28",
  "name": "Engine temperature sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor temperatur mesin."
 },
 {
  "dtc": "1E29",
  "code": "29",
  "name": "Decompression solenoid",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada thermistor."
 },
 {
  "dtc": "1E30",
  "code": "30",
  "name": "Lean angle sensor or Oil pressure dropped",
  "desc": "Kendaraan terdeteksi terguling."
 },
 {
  "dtc": "1E31",
  "code": "31",
  "name": "O2 sensor 1",
  "desc": "O2 Sensor stuck hingga batas terbawah"
 },
 {
  "dtc": "1E32",
  "code": "32",
  "name": "O2 sensor 1",
  "desc": "O2 Sensor stuck hingga batas terbesar"
 },
 {
  "dtc": "1E33",
  "code": "33",
  "name": "Ignition coil (#1)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #1 ignition coil."
 },
 {
  "dtc": "1E34",
  "code": "34",
  "name": "Ignition coil (#2)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #2 ignition coil."
 },
 {
  "dtc": "1E35",
  "code": "35",
  "name": "Ignition coil (#3)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #3 ignition coil."
 },
 {
  "dtc": "1E36",
  "code": "36",
  "name": "Ignition coil (#4)",
  "desc": "Sirkuit terbuka terdeteksi pada cylinder #4 ignition coil."
 },
 {
  "dtc": "1E37",
  "code": "37",
  "name": "ISC valve or FID valve",
  "desc": "Langsam terlalu besar."
 },
 {
  "dtc": "1E38",
  "code": "38",
  "name": "Decompression solenoid",
  "desc": "Sirkuit terbuka terdeteksi pada Solenoid dekompresi"
 },
 {
  "dtc": "1E39",
  "code": "39",
  "name": "Injector",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector primary"
 },
 {
  "dtc": "1E40",
  "code": "40",
  "name": "Secondary injector",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector secondary"
 },
 {
  "dtc": "1E41",
  "code": "41",
  "name": "Lean angle sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada lean angle sensor."
 },
 {
  "dtc": "1E42",
  "code": "42",
  "name": "Speed sensor or Neutral switch or Clutch switch",
  "desc": "Sinyal normal tidak diterima dari sensor kecepatan. Terjadi hubungan terbuka atau hubungan pendek pada switch netral atau switch"
 },
 {
  "dtc": "1E43",
  "code": "43",
  "name": "Fuel system voltage (monitoring voltage) or Engine stop",
  "desc": "Voltase yang salah dipasok ke injektor bahan bakar dan pompa bahan bakar. atau Sinyal yang benar tidak diterima dari sakelar pem"
 },
 {
  "dtc": "1E44",
  "code": "44",
  "name": "Error in writing on EEPROM",
  "desc": "Error terdeteksi ketika membaca atau menulis pada EEPROM."
 },
 {
  "dtc": "1E45",
  "code": "45",
  "name": "Faulty ECU",
  "desc": "Kerusakan internal pada sirkuit ECU."
 },
 {
  "dtc": "1E46",
  "code": "46",
  "name": "Vehicle system power supply",
  "desc": "tegangan berlebih ke ECU."
 },
 {
  "dtc": "1E47",
  "code": "47",
  "name": "Sub-throttle position sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada throttle position sensor."
 },
 {
  "dtc": "1E48",
  "code": "48",
  "name": "Sub-throttle motor",
  "desc": "Terdeteksinya stuck pada sub-throttle motor."
 },
 {
  "dtc": "1E50",
  "code": "50",
  "name": "ECU internal malfunction",
  "desc": "Kerusakan pada memory ECU."
 },
 {
  "dtc": "1E59",
  "code": "59",
  "name": "Accelerator position sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor accelerator."
 },
 {
  "dtc": "1E60",
  "code": "60",
  "name": "Throttle servo motor",
  "desc": "Kerusakan terjadi pada penggerak YCC-T."
 },
 {
  "dtc": "1E61",
  "code": "61",
  "name": "ISC valve",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada ISC (idle speed control) valve lead."
 },
 {
  "dtc": "1E62",
  "code": "62",
  "name": "Cooling fan temperature sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada Sensor temperatur pendingin Muffler."
 },
 {
  "dtc": "1E63",
  "code": "63",
  "name": "Cooling fan temperature sensor",
  "desc": "Temperatur tinggi (Abnormal) terdeteksi pada sensor temperatur muffler cooling fan."
 },
 {
  "dtc": "1E65",
  "code": "65",
  "name": "Knock sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor knock."
 },
 {
  "dtc": "1E66",
  "code": "66",
  "name": "Steering damper solenoid",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada steering damper solenoid lead"
 },
 {
  "dtc": "1E67",
  "code": "67",
  "name": "Oil pressure sensor",
  "desc": "Sinyal normal tidak diterima dari sensor tekanan oli."
 },
 {
  "dtc": "1E68",
  "code": "68",
  "name": "O2 sensor 2",
  "desc": "O2 Sensor tidak beroperasi."
 },
 {
  "dtc": "1E69",
  "code": "69",
  "name": "Front wheel sensor",
  "desc": "[Untuk MC]<br/> Tidak diterima sinyal yang normal dari sensor roda depan.<br/> [Untuk SMB]<br/> Solenoid katup pintasan udara ti"
 },
 {
  "dtc": "1E70",
  "code": "70",
  "name": "Engine idling stop",
  "desc": "Langsam mesin salah. (ECU akan secara otomatis memberhentikan mesin jika mesin salah langsam dalam 20 Menit)"
 },
 {
  "dtc": "1E71",
  "code": "71",
  "name": "O2 sensor heater",
  "desc": "Rangkaian pemanas sensor oksigen terbuka atau mengalami hubungan pendek; penggerak pemanas sensor tidak berfungsi dengan baik."
 },
 {
  "dtc": "1E73",
  "code": "73",
  "name": "Primary sheave position sensor",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada primary sheave position sensor."
 },
 {
  "dtc": "1E74",
  "code": "74",
  "name": "Secondary sheave speed sensor",
  "desc": "Normal sinyal tidak diterima dari secondary sheave speed sensor."
 },
 {
  "dtc": "1E75",
  "code": "75",
  "name": "Primary sheave",
  "desc": "Primary Sheave Terjepit."
 },
 {
  "dtc": "1E76",
  "code": "76",
  "name": "Primary sheave position",
  "desc": "Tidak terdeteksinya posisi Primary Sheave, atau tidak normalnya posisi primary sheave."
 },
 {
  "dtc": "1E77",
  "code": "77",
  "name": "Power supply for ECVT",
  "desc": "Tidak ada pasokan listrik ke motor ECU control."
 },
 {
  "dtc": "1E78",
  "code": "78",
  "name": "ECU internal temperature",
  "desc": "ECU terlalu panas."
 },
 {
  "dtc": "1E79",
  "code": "79",
  "name": "Abnormal intake air volume",
  "desc": "Langsam terlalu tinggi. Putaran mesin menurun dengan tidak benar."
 },
 {
  "dtc": "1E80",
  "code": "80",
  "name": "Grip warmer switch",
  "desc": "Sinyal normal tidak diterima dari switch grip warmer."
 },
 {
  "dtc": "1E81",
  "code": "81",
  "name": "Grip warmer",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada grip warmer lead."
 },
 {
  "dtc": "1E82",
  "code": "82",
  "name": "[For SMB] Thumb warmer switch (short circuit) [For engi",
  "desc": "[Untuk SMB] Sinyal yang diterima dari tombol pemanas tidak normal.<br/> [Untuk Idel mesin berhenti] Sinyal normal tidak diterima"
 },
 {
  "dtc": "1E83",
  "code": "83",
  "name": "Thumbs warmer",
  "desc": "Hubungan pendek pada Thumbs Warmer."
 },
 {
  "dtc": "1E84",
  "code": "84",
  "name": "[For SMB] T.O.R.S. warning [For VVA] VVA system (open o",
  "desc": "[Untuk SMB] T.O.R.S. berfungsi. (Katup trotel terjebak karena beku. Ini bukan gagal fungsi.)<br/> [Untuk VVA] Voltase tidak terd"
 },
 {
  "dtc": "1E85",
  "code": "85",
  "name": "Oil pressure switch",
  "desc": "Terjadi hubungan terbuka pada switch tekanan oli."
 },
 {
  "dtc": "1E88",
  "code": "88",
  "name": "[For SMB]Drive position switch or Reverse position swit",
  "desc": "[Untuk SMB]<br/> Sirkuit pendek pada sakelar FWD atau sakelar RVS.<br/> [Untuk SURE-PARK]<br/> Sinyal normal tidak dikirimkan ke"
 },
 {
  "dtc": "1E89",
  "code": "89",
  "name": "CAN communication",
  "desc": "Komunikasi data dari meter tidak dapat diterima dengan benar."
 },
 {
  "dtc": "1E90",
  "code": "90",
  "name": "Cruise control cancel switches",
  "desc": "Sinyal dari switch tidak dapat diterima dengan benar"
 },
 {
  "dtc": "1E91",
  "code": "91",
  "name": "Cruise control RES/SET switch",
  "desc": "Sinyal dari switch tidak dapat diterima dengan benar"
 },
 {
  "dtc": "1E92",
  "code": "92",
  "name": "Purge cut valve solenoid",
  "desc": "Rangkaian terbuka purge cut valve solenoid"
 },
 {
  "dtc": "1E96",
  "code": "96",
  "name": "Vehicle system power supply 2",
  "desc": "Baterai Lemah"
 },
 {
  "dtc": "1E98",
  "code": "98",
  "name": "IMU",
  "desc": "Sinyal gagal fungsi atau normal tidak diterima dari IMU."
 },
 {
  "dtc": "1E99",
  "code": "99",
  "name": "CAN transmission error (IMU)",
  "desc": "Data dari IMU tidak diterima dengan benar."
 },
 {
  "dtc": "2122",
  "code": "P2122",
  "name": "Accelerator position sensor (open or ground short circu",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor accelerator."
 },
 {
  "dtc": "2123",
  "code": "P2123",
  "name": "Accelerator position sensor (power short circuit for si",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor accelerator."
 },
 {
  "dtc": "2127",
  "code": "P2127",
  "name": "Accelerator position sensor (ground short circuit for s",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor accelerator."
 },
 {
  "dtc": "2128",
  "code": "P2128",
  "name": "Accelerator position sensor 2 (open or power short circ",
  "desc": "Terjadi hubungan terbuka atau hubungan pendek pada sensor accelerator."
 },
 {
  "dtc": "2135",
  "code": "P2135",
  "name": "Throttle position sensor (relationship between signal 1",
  "desc": "Sinyal normal tidak diterima dari sensor posisi gas."
 },
 {
  "dtc": "2138",
  "code": "P2138",
  "name": "Accelerator position sensor (relationship between signa",
  "desc": "Sinyal normal tidak diterima dari sensor posisi akselerator."
 },
 {
  "dtc": "2158",
  "code": "P2158",
  "name": "Front/rear speed sensor",
  "desc": "Tidak diterima sinyal yang normal dari sensor roda depan/belakang."
 },
 {
  "dtc": "2195",
  "code": "P2195",
  "name": "O2 sensor 1",
  "desc": "Sensor O2 #1 terputus atau tidak beroperasi."
 },
 {
  "dtc": "2197",
  "code": "P2197",
  "name": "O2 sensor 2",
  "desc": "Sensor O2 #2 terputus atau tidak beroperasi."
 },
 {
  "dtc": "21CF",
  "code": "P21CF",
  "name": "Secondary injector #1 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector secondary"
 },
 {
  "dtc": "21D0",
  "code": "P21D0",
  "name": "Secondary injector #2 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector secondary"
 },
 {
  "dtc": "21D1",
  "code": "P21D1",
  "name": "Secondary injector #3 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector secondary"
 },
 {
  "dtc": "21D2",
  "code": "P21D2",
  "name": "Secondary injector #4 (open circuit)",
  "desc": "Sirkuit terbuka terdeteksi pada arus injector secondary"
 },
 {
  "dtc": "2228",
  "code": "P2228",
  "name": "Atmospheric pressure sensor (ground short circuit)",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor tekanan atmosfir"
 },
 {
  "dtc": "2229",
  "code": "P2229",
  "name": "Atmospheric pressure sensor (open or power short circui",
  "desc": "Terjadi hubungan terbuka atau hubungan singkat pada sensor tekanan atmosfir"
 },
 {
  "dtc": "2270",
  "code": "P2270",
  "name": "Rear O2 sensor 1",
  "desc": "Sirkuit terbuka pada penghubung sensor O2 belakang No. 1."
 },
 {
  "dtc": "2272",
  "code": "P2272",
  "name": "Rear O2 sensor 2",
  "desc": "Sirkuit terbuka pada penghubung sensor O2 belakang No. 2."
 },
 {
  "dtc": "2645",
  "code": "P2645",
  "name": "VVA system (open or short circuit)",
  "desc": "Tegangan tidak terdeteksi saat solenoid beroperasi."
 },
 {
  "dtc": "4031",
  "code": "C0031",
  "name": "Front wheel speed sensor (left)/rear wheel speed sensor",
  "desc": "Sinyal yang benar tidak diterima dari sensor kecepatan roda depan (kiri)/sensor kecepatan roda belakang."
 },
 {
  "dtc": "4034",
  "code": "C0034",
  "name": "Front wheel speed sensor (right)/rear wheel speed senso",
  "desc": "Sinyal yang benar tidak diterima dari sensor kecepatan roda depan (kanan)/sensor kecepatan roda belakang."
 },
 {
  "dtc": "403D",
  "code": "C003D",
  "name": "Rear wheel speed sensor",
  "desc": "Tidak dapat menerima sinyal normal dari speed sensor roda belakang"
 },
 {
  "dtc": "4520",
  "code": "C0520",
  "name": "IMU",
  "desc": "Sinyal gagal fungsi atau normal tidak diterima dari IMU."
 },
 {
  "dtc": "5000",
  "code": "C1000",
  "name": "Steering damper solenoid (open/short to ground)",
  "desc": "Sirkuit terbuka atau pendek pada pada solenoid peredam setang."
 },
 {
  "dtc": "5009",
  "code": "C1009",
  "name": "SA system",
  "desc": "SA tetap terkunci dan tidak dapat berfungsi dengan benar"
 },
 {
  "dtc": "C101",
  "code": "U0101",
  "name": "CAN communication (with the MCU)",
  "desc": "Sinyal tidak dapat diterima dari MCU atau TCU."
 },
 {
  "dtc": "C125",
  "code": "U0125",
  "name": "CAN communication (with the IMU)",
  "desc": "Data dari IMU tidak dapat diterima dengan benar."
 },
 {
  "dtc": "C12A",
  "code": "U012A",
  "name": "CAN communication error (between ECU and SA-ECU)",
  "desc": "Tidak dapat menerima data dari SA-ECU dengan benar"
 },
 {
  "dtc": "C155",
  "code": "U0155",
  "name": "CAN communication error (with the meter)",
  "desc": "Data dari meteran tidak dapat diterima dengan benar."
 },
 {
  "dtc": "C402",
  "code": "U0402",
  "name": "CAN communication (incorrect signal is received from MC",
  "desc": "Sinyal kegagalan fungsi diterima dari MCU atau sinyal normal tidak diterima."
 }
];

export const dcodeByHex = (hex) => YAMAHA_DCODES.find((d) => d.code.toUpperCase() === String(hex || "").toUpperCase().padStart(2, "0"));

// value = raw byte(s) as integer; returns { text, unit }
export function decodeDcode(def, raw) {
  if (!def) return { text: `0x${Number(raw).toString(16).toUpperCase().padStart(2, "0")}`, unit: "" };
  if (def.consts) {
    const k = Number(raw).toString(16).toUpperCase().padStart(2, "0");
    return { text: def.consts[k] ? (k === "00" ? "OFF" : "ON") : `0x${k}`, unit: "" };
  }
  if (def.type === "convert" && def.denom) {
    const v = (Number(raw) * def.num) / def.denom + def.offset;
    return { text: v.toFixed(def.decimals || 0), unit: def.unit || "" };
  }
  return { text: String(raw), unit: "" };
}

export const dtcLookup = (q) => {
  const s = String(q || "").trim().toUpperCase();
  if (!s) return YAMAHA_DTC;
  return YAMAHA_DTC.filter((d) => d.code.toUpperCase().includes(s) || d.dtc.toUpperCase().includes(s) || d.name.toUpperCase().includes(s));
};
